import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ProductGridApp from './product-grid/ProductGridApp';
import SearchBoxApp from './search-box/SearchBoxApp';
import './styles/search-modal.css';
import './styles/product-grid.css';
import './styles/search-box.css';
function mountEnoWooSearch() {
    // Mount search modal app.
    const searchRoot = document.getElementById('eno-woo-search-root');
    if (searchRoot && !searchRoot.dataset.enoMounted) {
        searchRoot.dataset.enoMounted = '1';
        ReactDOM.createRoot(searchRoot).render(_jsx(React.StrictMode, { children: _jsx(App, {}) }));
    }
    // Mount product grid instances (one per [eno_product_grid] shortcode on the page).
    document.querySelectorAll('.eno-product-grid-root:not([data-eno-mounted])').forEach(el => {
        el.dataset.enoMounted = '1';
        const category = el.dataset.category ?? '';
        const perPage = Math.max(1, parseInt(el.dataset.perPage ?? '12', 10));
        const filterPortalId = el.dataset.filterPortal ?? '';
        ReactDOM.createRoot(el).render(_jsx(React.StrictMode, { children: _jsx(ProductGridApp, { initialCategory: category, perPage: perPage, filterPortalId: filterPortalId }) }));
    });
    // Mount inline search box instances (one per [eno_search_box] shortcode on the page).
    document.querySelectorAll('.eno-search-box-root:not([data-eno-mounted])').forEach(el => {
        el.dataset.enoMounted = '1';
        const placeholder = el.dataset.placeholder ?? '';
        ReactDOM.createRoot(el).render(_jsx(React.StrictMode, { children: _jsx(SearchBoxApp, { placeholder: placeholder }) }));
    });
}
// Run immediately if the DOM is already ready — caching/optimization plugins
// (e.g. WP Rocket's "delay JavaScript execution") often run our script well
// after DOMContentLoaded has already fired, so that listener would never call
// back. Also re-run when content is injected later (popups, AJAX-loaded
// builder elements, off-canvas panels, etc.) so late-appearing shortcodes
// still get mounted.
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountEnoWooSearch);
}
else {
    mountEnoWooSearch();
}
new MutationObserver(() => mountEnoWooSearch()).observe(document.body, { childList: true, subtree: true });
